import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import NavbarToggle from 'react-bootstrap/NavbarToggle';
import NavbarCollapse from 'react-bootstrap/NavbarCollapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import ServicesMegaMenu from './servicesmegamenu'; // Uncomment when available

export default function HeaderNav() {
	const navbarRef = useRef(null);
	const toggleButtonRef = useRef(null);
	const location = useLocation();

	const [isShowMenu, setIsShowMenu] = useState(false);
	const [expanded, setExpanded] = useState(false);

	const handleNavClick = () => {
		setExpanded(false);
		setIsShowMenu(false);
	};

	const handleMouseEnter = () => {
		setIsShowMenu(true);
	};

	const handleMouseLeave = () => {
		setIsShowMenu(false);
	};

	const handleClickOutside = (event) => {
		if (
			navbarRef.current &&
			!navbarRef.current.contains(event.target) &&
			toggleButtonRef.current &&
			!toggleButtonRef.current.contains(event.target)
		) {
			setExpanded(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const handleServiceClick = () => {
		if (window.innerWidth > 991) {
			setIsShowMenu(false);
		}
	};

	return (
		<Navbar expand="lg" expanded={expanded}>
			<NavbarToggle
				aria-controls="basic-navbar-nav"
				ref={toggleButtonRef}
				onClick={() => setExpanded((prev) => !prev)}
			/>
			<NavbarCollapse id="basic-navbar-nav" ref={navbarRef} className='justify-content-center'>
				<ul className="me-auto navbar-nav list-unstyled mb-0 me-lg-4 align-items-lg-center">
					<li>
						<Link
							to="/"
							className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Home

						</Link>
					</li>
					<li>
						<Link
							to="/earthworks"
							className={`nav-link ${location.pathname === '/earthworks' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Earthworks
						</Link>
					</li>
					<li>
						<Link
							to="/concrete"
							className={`nav-link ${location.pathname === '/concrete' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Concrete
						</Link>
					</li>
					<li>
						<Link
							to="/utilities"
							className={`nav-link ${location.pathname === '/utilities' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Utilities
						</Link>
					</li>
					<li>
						<Link
							to="/emergenci-service"
							className={`nav-link ${location.pathname === '/emergenci-service' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Emergency
						</Link>
					</li>
					
					{/* <li className='position-relative'>
						<div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
							<Link
								to="/services"
								className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}
								onClick={handleServiceClick}
							>
								CAPABILITIES
								<span className="dropdown-arrow ms-2">
									<FontAwesomeIcon icon={faChevronDown} />
								</span>
							</Link>
							<ServicesMegaMenu menuShowClass={isShowMenu ? "active" : ""} handleNavClick={handleNavClick} />
						</div>
					</li> */}
					<li>
						<Link
							to="/gallery"
							className={`nav-link ${location.pathname === '/gallery' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							Gallery
						</Link>
					</li>
					<li>
						<Link
							to="/about-us"
							className={`nav-link ${location.pathname === '/about-us' ? 'active' : ''}`}
							onClick={handleNavClick}
						>
							About Us
						</Link>
					</li>


				</ul>
			</NavbarCollapse>
			<Link to="/contact-us" className="btn btn-get-touch btn-solid-orange">
				<span className="d-none d-sm-block">Contact Us</span>
				<span className="d-block d-sm-none mobile-mail-envelope">
					<FontAwesomeIcon icon={faEnvelope} />
				</span>
			</Link>
		</Navbar>
	);
}
